import styled from 'styled-components';

export const AppContainer = styled.div`
  font-family: 'Roboto', sans-serif;
  text-align: center;
  height: 100%;
`;
